/*
 * Renders a property search card and its inquiry action.
 * The inquiry control must not navigate while the modal loads property details.
 */
import app from 'apprun';
import { __, lang } from '../Txlat';
import { getPropertyLink, getPropertyIcon, checkNumber, hasExactPropertyType, hasPropertyType } from '../utility';
import { getPropertyDetailStatusPrice } from '../model/property';
import InqueryTitle from '../agent-inquiry-title';

export default function ({ property, hightlight }) {
  const statusPrice = getPropertyDetailStatusPrice(property);

  const agent1 = { id: property.agent_person_id, alaia_id: property.agent_id, photo_path: property.agent_photo, name: property.agent_name, address: property.agent_address, city: property.agent_city, province: property.agent_province, postal_code: property.agent_postal_code, phone: property.agent_phone, email: property.agent_email, officeName: property.agent_office_name, title: property.agent_title, title_FR: property.agent_title_FR, isCommercailAgent: false };
  const agent2 = { id: property.agent2_person_id, alaia_id: property.agent2_id, photo_path: property.agent2_photo, name: property.agent2_name, address: property.agent2_address, city: property.agent2_city, province: property.agent2_province, postal_code: property.agent2_postal_code, phone: property.agent2_phone, email: property.agent2_email, officeName: property.agent_office_name, title: property.agent2_title, title_FR: property.agent_title_FR, isCommercailAgent: false };
  const inqueryTitle = <InqueryTitle agent1={agent1} agent2={agent2} />;

  const emailSubject = `${__('Inquiry regarding - ')}MLS ${property.mls_id} - ${property.address}`;
  let lotMeasure = '';
  let totalArea = '';

  if (
    (
      hasExactPropertyType(property.property_type[0], 'lot') || hasExactPropertyType(property.property_type[0], 'part woods')
      || hasExactPropertyType(property.property_type[0], 'part bush') || hasExactPropertyType(property.property_type[0], 'part cleared') || hasExactPropertyType(property.property_type[0], 'part workable')
      || hasPropertyType(property.property_type[0], 'mobile/mini') || hasPropertyType(property.property_type[0], 'no building onsite')
      || hasPropertyType(property.property_type[0], 'vacant') || hasPropertyType(property.property_type[0], 'acreage')
    )
    ||
    (hasPropertyType(property.property_type[0], 'agriculture') || hasPropertyType(property.property_type[0], 'farm'))

  ) {

    totalArea = String(property.total_area ?? '').split(';')[0];
    if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('meter')) {
      lotMeasure = __('Sq.M');
    } else if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('feet')) {
      lotMeasure = __('Sq.Ft');
    } else if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('acre')) {
      lotMeasure = __('acre');
    }
  } else {

    if (property.floorSpace) {
      totalArea = String(property.floorSpace ?? '').split(';')[0];
      if (property.floorSpaceUnits && property.floorSpaceUnits.toLowerCase().includes('meter')) {
        lotMeasure = __('Sq.M');
      } else if (property.floorSpaceUnits && property.floorSpaceUnits.toLowerCase().includes('feet')) {
        lotMeasure = __('Sq.Ft');
      } else if (property.floorSpaceUnits && property.floorSpaceUnits.toLowerCase().includes('acre')) {
        lotMeasure = __('acre');
      }

    } else {

      totalArea = String(property.total_area ?? '').split(';')[0];
      if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('meter')) {
        lotMeasure = __('Sq.M');
      } else if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('feet')) {
        lotMeasure = __('Sq.Ft');
      } else if (property.total_area_uom && property.total_area_uom.toLowerCase().includes('acre')) {
        lotMeasure = __('acre');
      }

    }

  }

  return (
    <div class="item-listing-wrap hz-item-gallery-js card" data-images="" style={hightlight ? 'border:3px solid red; width:100%; padding: 3px 5px; margin-bottom: 10px;' : 'padding: 3px 5px;margin-bottom: 10px;'} >
      <div class="item-wrap item-wrap-v1 item-wrap-no-frame h-100" >
        <div class="d-flex align-items-center h-100" style={hightlight ? 'flex-direction:row' : ''}>
          <div class="item-header">
            <div class="listing-image-wrap">
              <div class="listing-thumb">
                <a target={'property' + property.id} href={getPropertyLink(property, lang.get())} class="listing-featured-thumb">
                  <img width="280" height="210" src={property.property_photo} class="img-fluid wp-post-image" alt="" loading="lazy" style="width:280px !important; object-fit: cover;object-position:0 0; max-width: 100%; cursor: pointer; " />		</a>
              </div>
            </div>
            <div class="preview_loader"></div>
          </div>
          <div class="item-body flex-grow-1">
            <div class="pt-2">
              <label class="label-status red" style="color: red;">
                {statusPrice.status}
              </label>
              <div class="float-right">
                {hightlight && <a $onclick="close-highlighed-card"
                  style="position: absolute; right: 20px; top: 0px; cursor:pointer;color: red;font-size: 20px;font-weight: bold;">×</a>}
                <span class="item-price item-title">{statusPrice.price}</span>
              </div>
            </div>

            <ul class="item-amenities item-amenities-with-icons">
              <li>
                <h2 class="item-title" style="white-space: normal;">
                  <a target={'property' + property.id} href={getPropertyLink(property, lang.get())}><b>{property.address}</b></a>
                </h2>
              </li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li>{property.city?.toUpperCase()}&nbsp;{property.province?.toUpperCase()}&nbsp;{property.postal_code?.toUpperCase()}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              {totalArea ? <li class="h-area">
                <i class="houzez-icon icon-ruler-triangle mr-1"></i><span class="hz-figure">{checkNumber(totalArea)}</span>
                <span class="area_postfix">{' ' + lotMeasure}</span></li> : ''}
              <li>
                <span>{property.property_type ? lang.get() === 'en' ? (property.property_type[0] ? property.property_type[0].toUpperCase() : '') : (property.property_type[1] ? property.property_type[1].toUpperCase() : '') : ''}

                </span>
              </li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li><span>MLS® {property.mls_id} - {(property.distance).toFixed(2)} km</span></li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li><i class="houzez-icon icon-single-neutral mr-1"></i>20{property.last_updated.slice(0, 8)}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <div class="d-flex flex-row">
                <div class="flex-grow-1">
                  <button type="button" class="btn btn-search btn-secondary " style='line-height:30px;color:white;'
                    $onclick={['/openInqueryModal', { inqueryTitle: inqueryTitle, email: agent1.email, email2: agent2.email, agent1_name: agent1.name, agent2_name: agent2.name, inquiryType: 'PropertyInquiry', sub: emailSubject, property, agent1, agent2, form_type: 'Property', formName: 'propertySearch' }]}
                  >{__('Request Info')}</button>
                </div>
                <div class="mobile-switch">
                  <a class="float-right" onclick={() => app.run('/show-property-map', property)}>
                    <img src={getPropertyIcon(property.property_type)} style="height:30px; cursor: pointer;" />
                  </a>
                </div>
              </div>
            </ul>

          </div>
        </div>
      </div>
    </div>

  );
}
